import { makeStyles } from '@material-ui/core'

// Mirrors InventoryTabs' styles — the negative margins cancel the panel's page
// padding so the tab bar spans the full width, which is what makes the tab
// strip read as page chrome rather than as content.
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    marginRight: -96,
    marginLeft: -96,
    marginTop: -20,
    [theme.breakpoints.down('sm')]: {
      marginRight: -14,
      marginLeft: -15
    }
  },
  tabPanel: {
    paddingRight: 72,
    paddingLeft: 72,
    paddingTop: 24,
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
      paddingLeft: 0
    }
  },
  tab: {
    fontSize: 14,
    '&.Mui-selected': {
      border: `3px solid ${theme.palette.primary.main}`,
      borderTop: 'none'
    }
  },
  // The action row sits BELOW the tab strip and outside the panels: "New
  // ticket" applies to the ticket views as a group, so repeating it inside
  // each one would render the same button three times for one meaning.
  actionBar: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingRight: 72,
    paddingLeft: 72,
    paddingTop: 16,
    [theme.breakpoints.down('sm')]: {
      paddingRight: 16,
      paddingLeft: 16
    }
  }
}))

export default useStyles
